import { db } from '../services/firebase';
import { doc, setDoc } from 'firebase/firestore';

export const setupWholesaleTest = async (userId) => {
  try {
    // 1. Update user document with wholesale access
    await setDoc(doc(db, 'users', userId), {
      hasWholesaleAccess: true,
      email: 'test@example.com', // This will be overwritten if user already exists
      updatedAt: new Date().toISOString(),
    }, { merge: true }); // Using merge to preserve existing user data

    // 2. Create wholesale customer document
    await setDoc(doc(db, 'wholesaleCustomers', userId), {
      userId: userId,
      businessName: 'Test Business',
      status: 'approved',
      contactName: 'Test Contact',
      phoneNumber: '+974 1234 5678',
      email: 'test@example.com',
      address: {
        street: 'Test Street',
        city: 'Doha',
        country: 'Qatar'
      },
      creditLimit: 50000, // 50,000 QAR
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });

    console.log('Successfully set up wholesale test data');
    return true;
  } catch (error) {
    console.error('Error setting up wholesale test data:', error);
    throw error;
  }
}; 